export const BlogsData = [
    {
        "id": 1,
        "title": "How Machine Learning is Unveiling the Mysteries Hidden Within RNA-Protein Interactions",
        "image": "machine_learning_RNA_protein_interactions_thumb.webp",
        "date": "26 March, 2025",
        "shortDate": "26 Mar",
        "author": ["Hammad Qazi"],
        "categories": ["ML Industry"],
        "link": "blog1"
    },
    {
        "id": 2,
        "title": "When AI Gets Under Your Skin: The Future of Precision Medicine",
        "image": "applications_of_ai_in_precision_medicine_thumb.png",
        "date": "3 April, 2025",
        "shortDate": "3 Apr",
        "author": ["Esha Noor"],
        "categories": ["ML Industry"],
        "link": "blog2"
    },
    {
        "id": 3,
        "title": "How to Break Into AI Industry",
        "image": "breaking_into_ml_industry_thumb.webp",
        "date": "5 April, 2025",
        "shortDate": "5 Apr",
        "author": ["Bao Nguyen"],
        "categories": ["ML Industry"],
        "link": "blog3"
    },
    {
        "id": 4,
        "title": "How AI Chatbots Are Revolutionizing HR",
        "image": "how_ai_chatbots_are_revolutionizing_hr_thumb.webp",
        "date": "8 April, 2025",
        "shortDate": "8 Apr",
        "author": ["Esha Noor"],
        "categories": ["ML Industry"],
        "link": "blog4"
    },
    {
        "id": 5,
        "title": "Predicting Overdose Before It Happens",
        "image": "predicting_overdose_before_it_happens_thumb.webp",
        "date": "12 May, 2025",
        "shortDate": "12 May",
        "author": ["Esha Noor"],
        "categories": ["ML Industry"],
        "link": "blog5"
    },
    {
        "id": 6,
        "title": "How Digital Twin is Reshaping Our World into the Future",
        "image": "how_digital_twin_is_reshaping_thumb.webp",
        "date": "13 May, 2025",
        "shortDate": "13 May",
        "author": ["Bao Nguyen"],
        "categories": ["ML Industry"],
        "link": "blog6"
    },
    {
        "id": 7,
        "title": "How Convolutional Neural Networks (CNNs) are Advancing Security Systems in Finance",
        "image": "convolutional_neural_network_thumb.webp",
        "date": "28 May, 2025",
        "shortDate": "28 May",
        "author": ["Hammad Qazi"],
        "categories": ["ML Industry"],
        "link": "blog7"
    },
    {
        "id": 8,
        "title": "Diagnosing Mental Health Issues Using AI",
        "image": "diagnosing_mental_health_issues_thumb.webp",
        "date": "10 June, 2025",
        "shortDate": "10 Jun",
        "author": ["Esha Noor"],
        "categories": ["ML Industry"],
        "link": "blog8"
    },
    {
        "id": 9,
        "title": "How LSTM Networks are Preventing Traffic Jams Before They Happen",
        "image": "how_ltsm_networks_prevents_traffic_jams_thumb.webp",
        "date": "18 June, 2025",
        "shortDate": "18 Jun",
        "author": ["Hammad Qazi"],
        "categories": ["ML Industry"],
        "link": "blog9"
    },
    {
        "id": 10,
        "title": "Riding the AI Wave: Powering Our Future with Ocean Energy",
        "image": "riding_the_ai_wave_thumb.webp",
        "date": "23 June, 2025",
        "shortDate": "23 Jun",
        "author": ["Bao Nguyen"],
        "categories": ["ML Industry"],
        "link": "blog10"
    },
    {
        "id": 11,
        "title": "Predicting Disease Outbreaks Before They Spread Using AI",
        "image": "predicting_disease_outbreaks_thumb.webp",
        "date": "09 July, 2025",
        "shortDate": "09 Jul",
        "author": ["Esha Noor"],
        "categories": ["ML Industry"],
        "link": "blog11"
    },
    {
        "id": 12,
        "title": "Eyes of the Machine: How Computer Vision is Reshaping Quality Control",
        "image": "eyes_of_the_machine_thumb.webp",
        "date": "09 July, 2025",
        "shortDate": "09 Jul",
        "author": ["Hammad Qazi"],
        "categories": ["ML Industry"],
        "link": "blog12"
    },
    // {
    //     "id": 13,
    //     "title": "How to Break Into AI Industry",
    //     "image": "post-02.jpg",
    //     "date": "7 January, 2024",
    //     "shortDate": "7 Jan",
    //     "author": ["Bao Nguyen"],
    //     "categories": ["ML Industry"],
    //     "link": "blog1"
    // },
]